import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import type { ReactNode } from 'react';

export type RecommendationsIconProps = SvgIconProps;

export function RecommendationsIcon(props: RecommendationsIconProps): ReactNode {
  return (
    <SvgIcon viewBox="0 0 34 34" fill="155DFC" {...props}>
      <rect width="34" height="34" rx="17" fill="#155DFC" fill-opacity="0.1" />
      <path
        d="M11.2627 14.8621C11.2627 11.8246 13.7377 9.34961 17.0002 9.34961C20.2627 9.34961 22.7377 11.8246 22.7377 14.8621C22.7377 16.9996 21.5002 18.4621 20.3752 19.4746C19.8127 19.9246 19.5877 20.3746 19.5877 20.9371V21.4996H14.4127V20.9371C14.4127 20.3746 14.1877 19.9246 13.6252 19.4746C12.5002 18.4621 11.2627 16.9996 11.2627 14.8621Z"
        stroke="#155DFC"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0752 23.75L19.7002 23.75"
        stroke="#155DFC"
        stroke-width="1.3"
        stroke-linecap="round"
      />
      <path
        d="M17.0059 12.502C18.1309 12.6915 19.0652 13.627 19.2559 14.752"
        stroke="#155DFC"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  );
}
